import {SxType} from "@baseTypes/sx/sxTypes";
import {HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE, NAVIGATE_WIDTH_DESKTOP} from "@view/constants/size";
import {buildTitleLayerSelector} from "@ui/leafletCustom/titleLayer/helpers/buildTitleLayerSelector";
import {IS_SEPARATED} from "@constants/config";
import {ISxMap} from "@ui/leafletCustom/leafletContainer/types";
import {MediaStyle} from "@baseTypes/base";

const openstreetmapDarkTitleSelector = buildTitleLayerSelector('openstreetmapDark')
const cartoVoyagerDarkTitleSelector = buildTitleLayerSelector('cartoVoyagerDark')
const googleStreetsDarkTitleSelector = buildTitleLayerSelector('googleStreetsDark')
const googleHybridTitleSelector = buildTitleLayerSelector('googleHybrid')


export const sx: SxType = {
    root: {
        width: '100%',
        height: '100%',
        ...(IS_SEPARATED ? {
            '& .deviceIconCustomWrapper:after': {
                backgroundColor: '#474649',
                border: '#222222'
            },
        } : {}),
        '& .leaflet-control-attribution':{
           display:'none'
        },
        '& .leaflet-left': {
            left: {
                xs: 'calc(var(--map-left-offset, 0px) + 10px)',
                lg: 'calc(var(--map-left-offset, 0px) + 20px)',
            },
        },
        // the search accepts an address or pasted coordinates, and the default 200px input
        // clips that placeholder
        '& .leaflet-geosearch-button form': {
            maxWidth: {
                xs: 'calc(100vw - 90px)',
                lg: '430px',
            },
        },
        '& .leaflet-control-geosearch form input': {
            minWidth: {
                xs: '180px',
                lg: '330px',
            },
        },
        position: 'relative',
        '& .deviceIconCustomSvg path': {
            fill: '#FFFFFF'
        },
        '& .deviceIconArrowCustomSvg line': {
            stroke: '#222222'
        },

        '& .leaflet-popup-content': {
            overflowX: 'hidden',
            maxHeight: {
                xs: '45vh',
                lg: 'none',
            },
            overflowY: {
                xs: 'auto',
                lg: 'visible',
            },
            minWidth:{
                lg:'300px'
            },
            maxWidth: {
                xs: 'calc(100% - 40px)',
                lg: 'auto'
            }
        },
        '& .leaflet-marker-icon': {
            backgroundColor: 'transparent',
            border: 'none'
        },
        '& .leaflet-popup-content p': {
            margin: 'inherit'
        },
        '& .leaflet-popup-content-wrapper': {
            maxWidth: {
                xs: 'calc(100vw - 84px)',
                lg: `calc(50vw - ${NAVIGATE_WIDTH_DESKTOP})`,
            },
            '.showInfo &': {
                maxWidth: {
                    xs: 'calc(100vw - 84px)',
                    lg: `calc(50vw - ${NAVIGATE_WIDTH_DESKTOP} - 100px)`,
                },
            },
            backdropFilter: 'blur(6px)',
            '.lightTheme &': {
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
            },
            '.darkTheme &': {
                backgroundColor: 'rgba(24, 28, 30, 0.6)',
                color: '#fff'
            }
        },
        '& .leaflet-popup-tip': {
            backdropFilter: 'blur(6px)',
            '.lightTheme &': {
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
            },
            '.darkTheme &': {
                backgroundColor: 'rgba(24, 28, 30, 0.6)',
            },
        },
        [`&${googleHybridTitleSelector},&${googleStreetsDarkTitleSelector},&${openstreetmapDarkTitleSelector},&${cartoVoyagerDarkTitleSelector}`]: {
            '& .deviceIconCustomSvg path': {
                fill: '#fff'
            },
            '& .deviceIconArrowCustomSvg line': {
                stroke: '#fff'
            },
            ...(IS_SEPARATED ? {
                '& .deviceIconCustomWrapper:after': {
                    backgroundColor: 'rgba(0,0,0,.7)',
                    border: '1px solid #fff'
                },
            } : {}),

            '& .deviceIconCustomParkingSvgStroke': {
                stroke: '#fff'
            }
        },
        '& .deviceIconCustomParkingSvgStroke': {
            stroke: 'black'
        },
        [`&${openstreetmapDarkTitleSelector},&${googleStreetsDarkTitleSelector}`]: {
            ".leaflet-layer,.leaflet-control-zoom-in,.leaflet-control-zoom-out": {
                filter: "invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%)"
            },

            '& .leaflet-popup-content-wrapper, .leaflet-popup-tip': {
                color: '#fff'
            },
            '& .leaflet-container': {
                background: '#303030'
            },

        },
        [`&${cartoVoyagerDarkTitleSelector}`]: {
            '& .leaflet-container': {
                background: '#303030'
            },

        },
        fullScreenMode: {
            '.fullScreenMode &': {
                height: {
                    xs: 'calc(95vh - 40px)',
                    lg: 'calc(95vh - 40px)',
                }
            }
        }
    }
}


export const buildStyles = ({
                                sx: sxProps,
                                size,
                            }: {
    sx?: ISxMap,
    size?: {
        height?: MediaStyle<string | number>,
        width?: MediaStyle<string | number>,
    },
}) => {

    return {
        ...sx.root,
        '& .leaflet-container': {
            width: size?.width ?? '100%',
            height: size?.height ?? {
                xs: `calc(100vh - ${HEADER_HEIGHT_MOBILE})`,
                lg: `calc(100vh - ${HEADER_HEIGHT_DESKTOP})`,
            },

            ...sx.fullScreenMode,
            ...(sxProps?.map ? sxProps?.map : {}),
        },
        ...(sxProps?.search ? {'& .leaflet-geosearch-bar': sxProps?.search} : {}),
        ...(sxProps?.root ? sxProps.root : {}),
    }

}